

import "core-js/stable";
import "regenerator-runtime/runtime";

import { MODAL_CLOSE_MILSEC } from "./config.js";

import * as model from "./model.js";
import recipeView from "./views/recipe.js";
import searchView from "./views/search.js";
import resultsView from "./views/results.js";
import paginationView from "./views/pagination.js";
import bookmarksView from "./views/bookmarks.js";
import addRecipeView from "./views/addRecipe.js";

// https://forkify-api.herokuapp.com/v2

async function controlRecipes() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        
        recipeView.renderSpinner();
        
        await model.loadRecipe(id);
        
        // Re-render the search results sidebar - new ACTIVE recipe
        resultsView.update(model.getSearchResultsPage());
        recipeView.render(model.state.recipe);
        bookmarksView.update(model.state.bookmarks);
    } catch (error) {
        recipeView.renderErrorMessage();
    }
}


async function controlSearchResults() {
    try {
        const query = searchView.getQuery();
        if (!query) return;

        await model.loadSearchRecipe(query);
        resultsView.render(model.getSearchResultsPage());

        paginationView.render(model.state.search);
    } catch(error) {
        console.error(error);
    }
}


function controlPagination(page) {
    // Render NEW results
    resultsView.render(model.getSearchResultsPage(page));
    // Render NEW pagination buttons
    paginationView.render(model.state.search);
}


function controlServings(servings) {
    model.updateServings(servings);
    recipeView.update(model.state.recipe);
}


function controlBookmarks() {
    const { recipe } = model.state;
    model.toggleBookmark(recipe);
    recipeView.update(recipe);
    bookmarksView.render(model.state.bookmarks);
}


function controlLoadBookmarks() {
    bookmarksView.render(model.state.bookmarks);
}


async function controlRecipeUpload(data) {
    try {
        addRecipeView.renderSpinner();
        await model.uploadRecipe(data);
        
        recipeView.render(model.state.recipe);
        
        addRecipeView.renderSuccessMessage();
        bookmarksView.render(model.state.bookmarks);

        window.history.pushState(null, null, `#${model.state.recipe.id}`);

        setTimeout(function() {
            addRecipeView.toggleModal();
        }, MODAL_CLOSE_MILSEC);
    } catch(error) {
        addRecipeView.renderErrorMessage(error);
    }
}


function init() {
    bookmarksView.addHandlerLoadBookmarks(controlLoadBookmarks);
    recipeView.addHandlerAddBookmark(controlBookmarks);
    recipeView.addHandlerRender(controlRecipes);
    recipeView.addHandlerUpdateServings(controlServings);
    searchView.addHandlerRender(controlSearchResults);
    paginationView.addHandlerRender(controlPagination);
    addRecipeView.addHandlerUpload(controlRecipeUpload);
}


init();